import { motion } from "framer-motion";
import { Landmark, PanelTop, Home, Square, Paintbrush, Gem, Layers, Droplets } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { fadeUp, staggerWrap } from "./shared";
import { SERVICES } from "../lib/site";

const ICONS = {
    Landmark,
    PanelTop,
    Home,
    Square,
    Paintbrush,
    Gem,
    Layers,
    Droplets,
};

export default function Services() {
    const spans = [
        "lg:col-span-3",
        "lg:col-span-3",
        "lg:col-span-2",
        "lg:col-span-2",
        "lg:col-span-2",
        "lg:col-span-6",
    ];

    return (
        <section id="servizi" className="relative py-24 md:py-32" data-testid="services-section">
            <div className="max-w-7xl mx-auto px-5 md:px-8">
                <SectionHead
                    id="servizi"
                    eyebrow="Servizi"
                    title={
                        <>
                            Ogni superficie, <span className="text-aqua">la sua protezione.</span>
                        </>
                    }
                />

                <motion.div
                    variants={staggerWrap}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-3"
                    data-testid="services-bento"
                >
                    {SERVICES.map((s, i) => {
                        const Icon = ICONS[s.icon];
                        return (
                            <motion.article
                                key={s.n}
                                variants={fadeUp}
                                className={`group relative bg-panel border border-white/5 p-7 md:p-8 flex flex-col justify-between min-h-[220px] transition-colors duration-500 hover:border-aqua/40 hover:bg-card ${spans[i]}`}
                                data-testid={`service-card-${s.n}`}
                            >
                                <div className="flex items-start justify-between">
                                    <Icon
                                        className="w-7 h-7 text-aqua transition-transform duration-500 group-hover:-translate-y-1"
                                        strokeWidth={1.6}
                                    />
                                    <span className="font-mono2 text-xs text-ash/60 group-hover:text-ambra transition-colors duration-500">
                                        /{s.n}
                                    </span>
                                </div>
                                <div className="mt-10">
                                    <h3 className="font-display font-semibold tracking-tight text-xl text-cloud leading-snug">
                                        {s.title}
                                    </h3>
                                    <p className="mt-2.5 text-sm text-ash leading-relaxed max-w-md">
                                        {s.desc}
                                    </p>
                                </div>
                                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-ambra transition-all duration-500 group-hover:w-full" />
                            </motion.article>
                        );
                    })}
                </motion.div>
            </div>
        </section>
    );
}
